import classNames from "classnames";

import Accordion from "@stadium/ui/src/components/accordion/accordion";

import styles from "./main.module.scss";

const IngredientsAccordion = ({ ingredients }) => {
  if (!ingredients) return null;
  return (
    <Accordion
      id="dietary-restrictions"
      tabIndex={0}
      customClass={classNames(styles.panelGroup, styles.sharedDescriptionWithFlag)}
      titleContent={
        <div className={styles.acord}>
          <div className={styles.primaryColor}>Ingredients</div>
          <div className={`${styles.iconChevronUp} collapseicon`}></div>
        </div>
      }
    >
      <div className={styles.panelBodyInfo}>{ingredients}</div>
    </Accordion>
  );
};

export default IngredientsAccordion;
